import React, { Component } from 'react'

class OfflineIndicator extends Component {
  render () {
    /* eslint-disable */
    if (this.props.connected) return null
    return (
      <div className='offline-indicator text-left'>
        <i className='fa fa-spin fa-cog'></i>
        <span>Connection lost, reconnecting.</span>
      </div>
    )
  }
}
export default OfflineIndicator



// WEBPACK FOOTER //
// ./src/components/core/OfflineIndicator.js